const quoteCreationSteps = [
  {
    title: "Step",
    content: "First step ",
  },
  {
    title: "Step",
    content: "second step content",
  },
];
export default quoteCreationSteps;
